import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { mobileCSS } from '@measures/responsive'

const StyledDuration = styled.span`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: { white },
    },
  }) => {
    return css`
      font-family: ${sourceSansPro};
      font-weight: normal;
      font-size: 14px;
      line-height: 1.2;
      color: ${white};

      ${mobileCSS(css`
        font-size: 12px;
      `)}
    `
  }}
`

const Duration: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => <StyledDuration>{children}</StyledDuration>

export default Duration
